/* easygusto Bottega : fiche recette, comportement et impression (lot L3b, 9 octobre 2026).
   Module ES chargé par la section eg-recette : <script type="module" src="{{ 'eg-rcia-fiche.js' | asset_url }}"></script>.
   Il ne s'initialise que si document existe : node --test importe les fonctions pures exportées (R13).
   Entrées rendues par le Liquid (lot L3a) : <script type="application/json" data-rcia-etat> (R-plan § 2.5 amendé A8),
   <script type="application/json" data-rcia-config>, #eg-config (free, gauge, total, weight) et le balisage
   data-rcia-* / data-rl-* décrit dans rapports-bottega/R-L3b.md § 3.
   Règles fermes :
   - aucun appel au panier sans clic : seul « Tout ajouter » appelle EG.addMany, et seul son « Annuler » appelle EG.setQty ;
   - texte venu de l'état ou des traductions : textContent, ou esc() dans les panneaux (R12) ;
   - aucun stockage écrit : le passage de l'arbre (sessionStorage) est lu puis supprimé, rien d'autre ;
   - aucune adresse en dur : partage et QR code partent de etat.url (rendu par le Liquid) ;
   - une page A4 : la réduction est recalculée à chaque changement d'état, sur un clone hors écran, sans dépendre
     de beforeprint (R4). Le bloc d'impression .eg-rp est un enfant direct de <body>. */

export const VERSION = '1.0.0';
export const PASSAGE_CLE = 'eg-rcia-passage';
export const PASSAGE_DUREE_MS = 60000;
export const PORTIONS_MIN = 1;
export const PORTIONS_MAX = 16;
export const PAQUETS_MAX = 99;
/* Grand format (audit du 16/10 : sur 400 recettes à 4 portions, panier médian 38,60 € pour 6,72 € d'ingrédients utilisés) :
   un paquet d'au moins GF_RATIO fois la quantité de la recette et d'au moins GF_PRIX centimes n'est pas coché d'office. */
export const GF_RATIO = 5;
export const GF_PRIX = 1000;
export const ID_RE = /^[a-z][a-z0-9_]{0,15}$/;
/* Copies de vocabulaire.json (lot L0), contrôlées par égalité dans tests-js/fiche.test.mjs. */
export const DEJA = ['oeufs', 'parmesan', 'tomates', 'courgettes', 'champignons', 'creme', 'lardons', 'poulet', 'thon'];
export const COMMERCES = ['primeur', 'cremier', 'boucher', 'poissonnier', 'divers'];
export const AILLEURS = 'ailleurs';
export const UNITES = {
  g: 'demi_sous_10_puis_5_sous_50_puis_10',
  ml: 'demi_sous_10_puis_5_sous_50_puis_10',
  piece: 'demi_sup_sous_3_puis_entier_sup',
  gousse: 'demi_sup_sous_3_puis_entier_sup',
  tranche: 'demi_sup_sous_3_puis_entier_sup',
  feuille: 'demi_sup_sous_3_puis_entier_sup',
  botte: 'demi_sup_sous_3_puis_entier_sup',
  cas: 'demi_proche_min_demi',
  cac: 'demi_proche_min_demi',
  pincee: 'entier_min_1'
};
export const TRANCHES_BUDGET = [200, 400, 600];
export const BLOCS = ['ok', 'rupture', 'frais', 'deja', 'accompagner'];
/* A4 moins les marges de 12 mm (@page), et 6 mm de sécurité contre les écarts de rendu écran / impression. */
export const A4 = { largeurMm: 186, hauteurMm: 273, securiteMm: 6 };
export const REDUCTIONS = ['eg-rp-noimg', 'eg-rp-dense', 'eg-rp-xdense'];

/* Textes de repli (français), utilisés seulement si data-rcia-config ne fournit pas la clé (clé relative à eg.rcia.).
   Variables : __N__, __Q__, __P__ (prix), __M__ (montant), __T__ (titre), __PRODUIT__, __OK__, __KO__, __MAX__, __LISTE__. */
export const DEFAUTS = {
  'fiche.valeur': { one: '__N__ portion', other: '__N__ portions' },
  'fiche.besoin': '__Q__ pour la recette',
  'fiche.gf': 'Grand format : de quoi refaire la recette __N__ fois.',
  'fiche.gf_off': 'Grand format, non coché d’office : de quoi refaire la recette __N__ fois. Cochez-le pour l’ajouter.',
  'fiche.selon_gout': 'selon votre goût',
  'fiche.budget_b1': 'Moins de 2 € par portion',
  'fiche.budget_b2': '2 à 4 € par portion',
  'fiche.budget_b3': '4 à 6 € par portion',
  'fiche.budget_b4': 'Plus de 6 € par portion',
  'fiche.budget_note': 'hors produits frais',
  'fiche.plus_long': 'Un peu plus long que prévu : __N__ min.',
  'fiche.tout_ajouter': 'Tout ajouter au panier',
  'fiche.rien': 'Aucun produit coché',
  'fiche.ajoutes': { one: '__N__ produit ajouté au panier', other: '__N__ produits ajoutés au panier' },
  'fiche.partiel': 'Ajoutés au panier : __OK__ · indisponibles : __KO__',
  'fiche.aucun_ajout': 'Aucun produit n’a pu être ajouté. Réessayez dans un instant.',
  'fiche.annule': 'Ajout annulé',
  'fiche.non_relu': 'Votre panier n’a pas pu être relu. Ouvrez-le pour vérifier les produits ajoutés.',
  'fiche.jauge_reste': 'Plus que __M__ pour la livraison offerte',
  'fiche.jauge_ok': 'Livraison offerte avec ce panier',
  'fiche.poids': 'Colis de plus de __MAX__ kg : la livraison offerte ne s’applique plus',
  'fiche.lien_copie': 'Lien copié',
  'fiche.liste_titre': { one: 'Courses pour __T__ (__N__ portion)', other: 'Courses pour __T__ (__N__ portions)' },
  'fiche.liste_copiee': 'Liste copiée',
  'fiche.deja_btn': 'J’ai déjà',
  'fiche.deja_retirer': 'Je ne l’ai pas',
  'fiche.remplacer': 'Remplacer par…',
  'fiche.changer': 'Autre marque ou format',
  'fiche.swap_titre': 'Remplacer __PRODUIT__',
  'fiche.swap_choisir': 'Choisir',
  'fiche.swap_remplace': 'Remplace __PRODUIT__',
  'fiche.swap_actuel': 'Votre choix',
  'fiche.case': 'Commander __PRODUIT__',
  'fiche.sms': 'Envoyer par SMS',
  'fiche.copier': 'Copier la liste',
  'fiche.fermer': 'Fermer',
  'fiche.accompagner': 'Pour accompagner',
  'fiche.preparation': 'Préparation __N__ min',
  'fiche.cuisson': 'Cuisson __N__ min',
  'fiche.hors_ebullition': 'hors mise à ébullition de l’eau',
  'commerce.primeur': 'Primeur',
  'commerce.cremier': 'Crémier',
  'commerce.boucher': 'Boucher',
  'commerce.poissonnier': 'Poissonnier',
  'commerce.divers': 'Divers',
  'commerce.ailleurs': 'À trouver ailleurs',
  'unite.g': '__Q__ g',
  'unite.ml': '__Q__ ml',
  'unite.kg': '__Q__ kg',
  'unite.l': '__Q__ l',
  'unite.piece': { one: '__Q__ pièce', other: '__Q__ pièces' },
  'unite.gousse': { one: '__Q__ gousse', other: '__Q__ gousses' },
  'unite.tranche': { one: '__Q__ tranche', other: '__Q__ tranches' },
  'unite.feuille': { one: '__Q__ feuille', other: '__Q__ feuilles' },
  'unite.botte': { one: '__Q__ botte', other: '__Q__ bottes' },
  'unite.cas': '__Q__ c. à soupe',
  'unite.cac': '__Q__ c. à café',
  'unite.pincee': { one: '__Q__ pincée', other: '__Q__ pincées' },
  'allergenes': 'Contient probablement : __LISTE__ · vérifiez les étiquettes',
  'allergene.gluten': 'gluten',
  'allergene.crustaces': 'crustacés',
  'allergene.oeufs': 'œufs',
  'allergene.poissons': 'poissons',
  'allergene.arachides': 'arachides',
  'allergene.soja': 'soja',
  'allergene.lait': 'lait',
  'allergene.fruits_a_coque': 'fruits à coque',
  'allergene.celeri': 'céleri',
  'allergene.moutarde': 'moutarde',
  'allergene.sesame': 'sésame',
  'allergene.sulfites': 'sulfites',
  'allergene.lupin': 'lupin',
  'allergene.mollusques': 'mollusques',
  'print.titre': 'Imprimer la recette',
  'print.sans_image': 'Sans image (moins d’encre)',
  'print.ok': 'Imprimer',
  'print.pdf': 'Pour un PDF, choisissez « Enregistrer en PDF » dans la fenêtre d’impression.',
  'print.courses': 'Liste de courses',
  'print.eg': 'Chez ITALAZA',
  'print.frais': 'À prévoir (frais)',
  'print.deja': 'Vous l’avez déjà',
  'print.preparation': 'Préparation',
  'print.astuce': 'Astuce',
  'print.qr': 'Retrouvez la recette et ses produits',
  'print.pour': { one: 'Pour __N__ personne', other: 'Pour __N__ personnes' },
  'mention.recette': 'Recette créée avec l’aide de l’IA et relue par ITALAZA',
  'mention.image_ia': 'Illustration',
  'mention.testee': '★ Testée'
};
/* Clés lues dans data-rcia-config.t (le Liquid les émet ; liste vérifiée par le test et par L6). */
export const CLES_T = Object.keys(DEFAUTS).concat(['mention.photo_produit']);

/* ---------- Fonctions pures (testées sous Node) ---------- */

const ALIAS = { prix: 'P', montant: 'M', titre: 'T' };

/* Langue de la page (attribut lang de <html>, « fr » par défaut) : règle du singulier et ponctuation. */
const estFr = (lang) => /^fr\b/i.test(String(lang || 'fr'));

/* Forme « one » : sous 2 en français (« 1 ½ gousse ») ; pour l'allemand et les autres langues, 1 exactement (CLDR). */
export function estUn(n, lang) {
  const x = Number(n);
  return estFr(lang) ? x < 2 : x === 1;
}

/* Deux-points : espace insécable avant en français (« Astuce : »), aucune ailleurs (« Tipp: »). */
export function deuxPoints(lang) {
  return estFr(lang) ? ' : ' : ': ';
}

/* Texte traduit : t[cle] (chaîne, ou { one, other } choisi par count selon la langue, voir estUn),
   sinon le texte de repli ; chaque variable remplace __NOM__ (et son alias court : __P__, __M__, __T__). */
export function texte(t, cle, vars, lang) {
  const v0 = t && Object.prototype.hasOwnProperty.call(t, cle) ? t[cle] : DEFAUTS[cle];
  const o = vars || {};
  let v = v0;
  if (v && typeof v === 'object') {
    const one = o.count != null && estUn(o.count, lang);
    v = (one ? v.one : v.other) || v.other || v.one;
  }
  if (typeof v !== 'string') return '';
  Object.keys(o).forEach((k) => {
    if (k === 'count') return;
    const val = String(o[k]);
    v = v.split('__' + k.toUpperCase() + '__').join(val);
    if (ALIAS[k]) v = v.split('__' + ALIAS[k] + '__').join(val);
  });
  return v;
}

/* Nombre affiché : entier, « ½ », « 1 ½ » (espace insécable), sinon une décimale avec virgule. */
export function nombre(q) {
  const e = 1e-9;
  const ent = Math.floor(q + e);
  const frac = q - ent;
  if (Math.abs(frac) < e) return String(ent);
  if (Math.abs(frac - 0.5) < e) return ent ? ent + ' ½' : '½';
  return String(Math.round(q * 10) / 10).replace('.', ',');
}

/* Arrondi par unité (vocabulaire UNITES, R-plan § 2.2). */
export function arrondir(x, u) {
  const e = 1e-9;
  if (!(x > 0)) return 0;
  switch (UNITES[u]) {
    /* Sous 10 g ou 10 ml : au ½ le plus proche (½ au moins), pour la levure, le sel, les épices (audit du 9/10, P10). */
    case 'demi_sous_10_puis_5_sous_50_puis_10':
      if (x < 10) return Math.max(0.5, Math.round(x * 2) / 2);
      return x < 50 ? Math.round(x / 5) * 5 : Math.round(x / 10) * 10;
    case 'demi_sup_sous_3_puis_entier_sup': return x < 3 ? Math.ceil(x * 2 - e) / 2 : Math.ceil(x - e);
    case 'demi_proche_min_demi': return Math.max(0.5, Math.round(x * 2) / 2);
    case 'entier_min_1': return Math.max(1, Math.round(x));
    default: return Math.round(x * 10) / 10;
  }
}

/* Quantité pour p portions : pp × p arrondie selon l'unité ; null si « selon votre goût » (pp ou unité absente). */
export function quantite(l, p) {
  if (!l || l.pp == null || !l.u || !(Number(l.pp) > 0)) return null;
  return arrondir(Number(l.pp) * p, l.u);
}

/* « 400 g », « ½ gousse », « 1 ½ c. à soupe » ; singulier sous 2 ; « selon votre goût » pour null. */
export function texteQte(q, u, t, lang) {
  if (q == null) return texte(t, 'fiche.selon_gout', null, lang);
  if ((u === 'g' || u === 'ml') && q >= 1000) {
    /* 1 000 g et plus : « 1,6 kg » ; 1 000 ml et plus : « 2 l » (une décimale). */
    const k = Math.round(q / 100) / 10;
    const nk = String(k).replace('.', ',');
    return texte(t, u === 'g' ? 'unite.kg' : 'unite.l', { q: nk, count: k }, lang) || (nk + (u === 'g' ? ' kg' : ' l'));
  }
  /* g et ml : « 2,5 g » plutôt que « 2 ½ g » (demi-gramme sous 10 g). */
  const n = (u === 'g' || u === 'ml') ? String(q).replace('.', ',') : nombre(q);
  return texte(t, 'unite.' + u, { q: n, count: q }, lang) || (n + ' ' + (u || ''));
}

/* Nombre de paquets : max(1, ceil(quantité affichée ÷ contenance)) ; 1 si la contenance ou la quantité manque. */
export function paquets(l, p, c) {
  const cc = c === undefined ? (l && l.c) : c;
  const q = quantite(l, p);
  if (q == null || !(Number(cc) > 0)) return 1;
  return Math.max(1, Math.ceil(q / Number(cc) - 1e-9));
}

/* Bloc d'une ligne pour un modèle { choix, dejaOn } : « deja » (placard ou déclaré), « ok », « rupture », « frais ».
   Une ligne en rupture remplacée par un remplaçant devient « ok ». */
export function blocDe(l, m) {
  const mm = m || {};
  if (l.st === 'placard' || mm.dejaOn) return 'deja';
  if (l.st === 'ok') return 'ok';
  if (l.st === 'rupture') return mm.choix >= 0 ? 'ok' : 'rupture';
  return 'frais';
}

/* Statut initial (R-plan § 2.6) : déclaré « J'ai déjà » ou placard → deja ; disponible → ok ; rupture → rupture ;
   produit introuvable ou rupture sans remplaçant (rendus « frais » par le Liquid) et frais → frais. */
export function statutInitial(l, dejaSet) {
  const on = !!(l.deja && dejaSet && dejaSet.has(l.deja));
  return blocDe(l, { choix: -1, dejaOn: on });
}

export function produitCourant(l, m) {
  if (m && m.choix >= 0) return (l.alt || [])[m.choix] || null;
  return l.p || null;
}

export function contenance(l, m) {
  if (m && m.choix >= 0) { const a = (l.alt || [])[m.choix]; return a ? a.c : undefined; }
  return l.c;
}

/* Case utilisable : produit courant disponible, hors rupture et hors frais (R16 : un produit indisponible du bloc 🏠 est bloqué). */
export function caseActive(l, m) {
  const pr = produitCourant(l, m);
  const b = blocDe(l, m);
  return !!(pr && pr.dispo) && (b === 'ok' || b === 'deja');
}

/* Remplaçants proposables : produit principal (k = -1) et alt disponibles, sauf le choix courant. */
export function candidats(l, m) {
  const out = [];
  const cur = m ? m.choix : -1;
  if (l.p && l.p.dispo && cur !== -1) out.push({ k: -1, p: l.p, c: l.c });
  (l.alt || []).forEach((a, i) => { if (a && a.dispo && i !== cur) out.push({ k: i, p: a, c: a.c }); });
  return out;
}

/* Grand format : nombre de fois que le paquet couvre la recette (0 si ce n'est pas un grand format). */
export function grandFormat(l, m, p) {
  const pr = produitCourant(l, m);
  const c = Number(contenance(l, m));
  const q = quantite(l, p);
  if (!pr || !pr.dispo || !(c > 0) || q == null || !(q > 0)) return 0;
  if (c < GF_RATIO * q || (Number(pr.prix) || 0) < GF_PRIX) return 0;
  return Math.floor(c / q + 1e-9);
}

export function modeleInitial(etat, p, dejaSet) {
  const lignes = {};
  (etat.lignes || []).forEach((l) => {
    const m = { choix: -1, dejaOn: !!(l.deja && dejaSet && dejaSet.has(l.deja)), ck: false, n: 0 };
    m.ck = blocDe(l, m) === 'ok' && caseActive(l, m) && !grandFormat(l, m, p);
    m.n = paquets(l, p, contenance(l, m));
    lignes[l.id] = m;
  });
  return { p, lignes };
}

/* Lignes envoyées par « Tout ajouter » : cochées, case active (bloc ok ou 🏠 avec produit disponible), au moins 1 paquet.
   Jamais une ligne frais ni une rupture non remplacée. Quantités regroupées par variante. */
export function planAjout(etat, mod) {
  const par = new Map();
  (etat.lignes || []).forEach((l) => {
    const m = mod.lignes[l.id];
    if (!m || !m.ck || !(m.n > 0) || !caseActive(l, m)) return;
    const pr = produitCourant(l, m);
    const k = String(pr.vid);
    const prev = par.get(k);
    if (prev) prev.quantity += m.n;
    else par.set(k, { id: pr.vid, quantity: m.n, prix: Number(pr.prix) || 0, poids: Number(pr.poids) || 0 });
  });
  return Array.from(par.values());
}

export function total(etat, mod) {
  return planAjout(etat, mod).reduce((s, it) => s + it.quantity * it.prix, 0);
}

export function poidsSelection(etat, mod) {
  return planAjout(etat, mod).reduce((s, it) => s + it.quantity * it.poids, 0);
}

/* Part de la sélection qui n'est pas encore au panier (jauge) : Σ max(0, paquets − quantité au panier) × prix, et le
   poids correspondant. Sans cela, juste après « Tout ajouter », panier et sélection compteraient deux fois les mêmes
   produits, et la jauge pourrait annoncer « Livraison offerte » pour un panier qui n'y a pas droit. */
export function horsPanier(plan, qty) {
  const q = typeof qty === 'function' ? qty : () => 0;
  return plan.reduce((s, it) => {
    const n = Math.max(0, it.quantity - (Number(q(String(it.id))) || 0));
    return { montant: s.montant + n * it.prix, poids: s.poids + n * it.poids };
  }, { montant: 0, poids: 0 });
}

/* Budget par portion, en centimes : Σ prix × pp ÷ contenance sur les lignes produit disponibles hors placard
   (une déclaration « J'ai déjà » ne change pas le coût de la recette). null s'il n'y a aucune ligne de ce genre. */
export function budgetPortion(etat, mod) {
  let s = 0;
  let nb = 0;
  (etat.lignes || []).forEach((l) => {
    if (l.st === 'placard') return;
    const m = mod.lignes[l.id] || { choix: -1 };
    if (blocDe(l, { choix: m.choix, dejaOn: false }) !== 'ok') return;
    const pr = produitCourant(l, m);
    const c = Number(contenance(l, m));
    if (!pr || !pr.dispo || l.pp == null || !(c > 0)) return;
    s += (Number(pr.prix) || 0) * Number(l.pp) / c;
    nb++;
  });
  return nb ? Math.round(s) : null;
}

/* Tranche : b1 < 2 € ; b2 de 2 à 4 € ; b3 de 4,01 à 6 € ; b4 au-delà. */
export function trancheBudget(c) {
  if (c == null || !(c >= 0)) return null;
  if (c < TRANCHES_BUDGET[0]) return 'b1';
  if (c <= TRANCHES_BUDGET[1]) return 'b2';
  if (c <= TRANCHES_BUDGET[2]) return 'b3';
  return 'b4';
}

/* Jauge de livraison offerte : panier + sélection comparés au seuil ; « lourd » au-delà du poids maximal (grammes). */
export function jauge(totalPanier, sel, seuil, poidsTotal, poidsMax) {
  const tt = Math.max(0, Number(totalPanier) || 0) + Math.max(0, Number(sel) || 0);
  const s = Math.max(1, Number(seuil) || 0);
  const lourd = Number(poidsMax) > 0 && Number(poidsTotal) > Number(poidsMax);
  const reste = Math.max(0, s - tt);
  return { pct: Math.min(100, Math.round((tt * 100) / s)), reste, offerte: !lourd && reste === 0, lourd };
}

/* Liste « Envoyer la liste » (courses hors ITALAZA) : frais par commerce, puis « À trouver ailleurs » (produits
   introuvables ou épuisés SANS remplaçant, que le Liquid rend « frais » dans « ailleurs ») ; texte brut, sans prix ni
   emoji. Les lignes déclarées « J'ai déjà » n'y sont pas, ni une rupture qui a un remplaçant ITALAZA disponible
   (R-plan § 1.4 ; R-decisions point 10 : on n'envoie pas ailleurs ce que nous vendons). */
export function listeTexte(etat, mod, t, lang) {
  const groupes = {};
  (etat.lignes || []).forEach((l) => {
    const m = mod.lignes[l.id];
    if (!m) return;
    if (blocDe(l, m) !== 'frais') return;
    const c = COMMERCES.indexOf(l.commerce) >= 0 || l.commerce === AILLEURS ? l.commerce : 'divers';
    const q = quantite(l, mod.p);
    (groupes[c] = groupes[c] || []).push('- ' + l.nom + (q == null ? '' : deuxPoints(lang) + texteQte(q, l.u, t, lang)));
  });
  const out = [texte(t, 'fiche.liste_titre', { titre: etat.titre, n: mod.p, count: mod.p }, lang)];
  COMMERCES.concat([AILLEURS]).forEach((c) => {
    if (!groupes[c]) return;
    out.push('', texte(t, 'commerce.' + c, null, lang));
    groupes[c].forEach((x) => out.push(x));
  });
  return out.join('\n');
}

/* Quantités par variante d'un panier relu sur le serveur ({ items: [{ variant_id, quantity }] }), null s'il est illisible.
   Sert au bilan et à « Annuler » : les compteurs E.qty() d'eg-app.js peuvent être optimistes ou figés pendant un autre
   changement du panier (audit du 9/10, J5 et J6). */
export function qtesPanier(c) {
  if (!c || !Array.isArray(c.items)) return null;
  const m = new Map();
  c.items.forEach((it) => {
    const k = String(it && it.variant_id);
    m.set(k, (m.get(k) || 0) + (Number(it && it.quantity) || 0));
  });
  return m;
}

/* Bilan d'un ajout : ajouté = quantité au panier après − avant (mesurée, pas demandée, R5), jamais plus que la quantité
   envoyée (un « + » du client sur la même variante pendant l'envoi n'est pas compté comme ajouté par la recette).
   ok = variantes ajoutées (au moins 1) ; ko = variantes ajoutées en partie ou pas du tout. */
export function bilanAjout(plan, avant, apres) {
  const ajoutes = [];
  let ok = 0;
  let ko = 0;
  plan.forEach((it) => {
    const k = String(it.id);
    const n = Math.min(Number(it.quantity) || 0, Math.max(0, (Number(apres(k)) || 0) - (Number(avant.get(k)) || 0)));
    if (n > 0) { ok++; ajoutes.push({ vid: k, n }); }
    if (n < it.quantity) ko++;
  });
  return { ok, ko, ajoutes };
}

/* Cibles de « Annuler » : quantité actuelle − quantité réellement ajoutée, jamais sous 0. */
export function ciblesAnnulation(ajoutes, qty) {
  return ajoutes.map((a) => ({ vid: a.vid, q: Math.max(0, (Number(qty(a.vid)) || 0) - a.n) }));
}

/* Passage de l'arbre (sessionStorage, A8) : { h, deja[], x[], ctx[], t }, valable si h = handle de la fiche et âge ≤ 60 s.
   Valeurs filtrées sur le vocabulaire ; tout le reste est ignoré. */
export function lirePassage(brut, h, maintenant, duree) {
  let o;
  try { o = JSON.parse(brut); } catch (e) { return null; }
  if (!o || typeof o !== 'object' || typeof o.h !== 'string' || o.h !== h) return null;
  const age = Number(maintenant) - Number(o.t);
  if (!(age >= 0 && age <= (duree == null ? PASSAGE_DUREE_MS : duree))) return null;
  const liste = (a, ok) => (Array.isArray(a) ? Array.from(new Set(a.filter((x) => typeof x === 'string' && ok.indexOf(x) >= 0))) : []);
  return { deja: liste(o.deja, DEJA), x: liste(o.x, ['temps']), ctx: liste(o.ctx, ['enfants']) };
}

/* Fragment d'adresse : #p=N (1 à 16, sinon portions de base) et #…&imprimer=1 (ouvre le panneau d'impression). */
export function lireAdresse(hash, pbase) {
  const prm = {};
  String(hash || '').replace(/^#/, '').split('&').forEach((kv) => {
    if (!kv) return;
    const i = kv.indexOf('=');
    if (i > 0) prm[kv.slice(0, i)] = kv.slice(i + 1);
    else prm[kv] = '';
  });
  const base = Number(pbase) >= PORTIONS_MIN && Number(pbase) <= PORTIONS_MAX ? Math.floor(Number(pbase)) : 4;
  let p = /^\d{1,2}$/.test(prm.p || '') ? Number(prm.p) : NaN;
  if (!(p >= PORTIONS_MIN && p <= PORTIONS_MAX)) p = base;
  return { p, imprimer: prm.imprimer === '1' };
}

/* Nom court d'un produit, comme nm() d'eg-app.js et le snippet eg-name : sans « – Format … » ni « (500 g) » final. */
export function nomCourt(titre) {
  const s = String(titre == null ? '' : titre).replace(/[  ]/g, ' ').replace(/\s*[–-]\s*Format.*$/, '').trim();
  return s.replace(/\s*\(\s*[\d.,\s]*\d[\d.,\s]*(kg|ml|cl|g|l)\s*\)\s*$/i, '').trim();
}

/* Réduction pour tenir sur une page : premier palier dont la hauteur mesurée tient dans la limite, sinon le dernier. */
export function choisirReduction(mesurer, limite, sansImage) {
  const paliers = sansImage
    ? [['eg-rp-noimg'], ['eg-rp-noimg', 'eg-rp-dense'], ['eg-rp-noimg', 'eg-rp-dense', 'eg-rp-xdense']]
    : [[], ['eg-rp-noimg'], ['eg-rp-noimg', 'eg-rp-dense'], ['eg-rp-noimg', 'eg-rp-dense', 'eg-rp-xdense']];
  let h = 0;
  for (const cl of paliers) {
    h = mesurer(cl);
    if (h <= limite) return { classes: cl, tient: true, hauteur: h };
  }
  return { classes: paliers[paliers.length - 1], tient: false, hauteur: h };
}

export function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

/* Prix au format français, identique à EG.money et au snippet eg-money. */
export function money(cents) {
  let c = Math.round(Number(cents) || 0);
  const sign = c < 0 ? '−' : '';
  c = Math.abs(c);
  return sign + Math.floor(c / 100) + ',' + String(c % 100).padStart(2, '0') + ' €';
}

/* Adresse affichable (src, href) : chemin du site ou https. Sinon chaîne vide. */
export function urlSure(u) {
  const s = String(u == null ? '' : u).trim();
  /* Chemin de la boutique (« /… », jamais « //hôte » ni « /\hôte ») ou adresse en https suivie de deux barres (audit S12).
     Les images de l'état sont déjà en https (prepend du Liquid). */
  return /^(\/(?![\/\\])|https:\/\/)/i.test(s) ? s : '';
}

/* Largeur demandée au CDN : remplace un width= déjà présent (image_url du Liquid), sinon l'ajoute. */
export function sized(url, w) {
  const u = urlSure(url);
  if (!u) return '';
  if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
  return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
}

/* ---------- Comportement de la page ---------- */

function lireJSON(el) {
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
}

const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export function init(root, env) {
  const opt = env || {};
  const doc = root.ownerDocument;
  const win = opt.win || doc.defaultView;
  const eg = () => opt.EG || win.EG || null;
  const q1 = (sel) => root.querySelector(sel) || doc.querySelector(sel);
  const etat0 = lireJSON(q1('script[data-rcia-etat]'));
  if (!etat0 || !Array.isArray(etat0.lignes) || typeof etat0.h !== 'string') return null;
  const lignes = etat0.lignes.filter((l) => l && ID_RE.test(String(l.id)));
  const etat = Object.assign({}, etat0, { lignes, acc: Array.isArray(etat0.acc) ? etat0.acc : [] });
  const cfg = lireJSON(q1('script[data-rcia-config]')) || {};
  const egcfg = lireJSON(doc.getElementById('eg-config')) || {};
  const t = cfg.t && typeof cfg.t === 'object' ? cfg.t : {};
  const lang = doc.documentElement.getAttribute('lang') || 'fr';
  const T = (cle, vars) => texte(t, cle, vars, lang);
  const Q = (q, u) => texteQte(q, u, t, lang);
  const DP = deuxPoints(lang);
  const ctl = new AbortController();
  const sig = { signal: ctl.signal };
  const ordre = new Map(lignes.map((l, i) => [l.id, i]));
  const parId = new Map(lignes.map((l) => [l.id, l]));

  /* Adresse publique de la fiche (Liquid : request.origin + system.url) ; rien si elle n'est pas en http(s). */
  let urlBase = '';
  try {
    const u = new win.URL(String(etat.url || ''), win.location.href);
    if (u.protocol === 'https:' || u.protocol === 'http:') { u.hash = ''; urlBase = u.href; }
  } catch (e) { urlBase = ''; }
  let hote = '';
  try { hote = urlBase ? new win.URL(urlBase).host.replace(/^www\./, '') : ''; } catch (e) { hote = ''; }

  const adr = lireAdresse(win.location.hash, etat.pbase);

  /* Passage de l'arbre : lu puis supprimé, toujours (même périmé). */
  let passage = null;
  try {
    const s = win.sessionStorage;
    const brut = s.getItem(PASSAGE_CLE);
    if (brut != null) {
      s.removeItem(PASSAGE_CLE);
      passage = lirePassage(brut, etat.h, Date.now(), PASSAGE_DUREE_MS);
    }
  } catch (e) { passage = null; }
  const mod = modeleInitial(etat, adr.p, new Set(passage ? passage.deja : []));
  const enfants = !!(passage && passage.ctx.indexOf('enfants') >= 0);

  /* Lignes rendues par le Liquid, et leur conteneur d'origine (retour d'une ligne sortie de 🏠). */
  const rows = new Map();
  const homes = new Map();
  lignes.forEach((l) => {
    const r = root.querySelector('[data-rl="' + l.id + '"]');
    if (!r) return;
    rows.set(l.id, r);
    const b = r.closest('[data-rcia-bloc]');
    homes.set(l.id, { el: r.parentElement, bloc: b ? b.getAttribute('data-rcia-bloc') : '' });
    r.setAttribute('data-rl-choix', '-1');
  });
  /* Aucun ajout invisible : une ligne de l'état sans case rendue sur la page n'est jamais cochée. */
  lignes.forEach((l) => {
    const r = rows.get(l.id);
    if (!r || !r.querySelector('[data-rl-ck]')) mod.lignes[l.id].ck = false;
  });

  const panier = { total: num(egcfg.total), poids: num(egcfg.weight) };
  let sansImage = false;
  let occupe = false;
  let qr = { url: null, noeud: null };

  /* Bloc d'impression : enfant direct de <body> (la feuille d'impression masque tout le reste). */
  let rp = root.querySelector('[data-rcia-print]');
  const ancien = doc.getElementById('eg-rp');
  if (ancien && ancien !== rp) ancien.remove();
  if (!rp) rp = doc.createElement('div');
  rp.id = 'eg-rp';
  rp.className = 'eg-rp';
  rp.setAttribute('data-rcia-print', '');
  rp.setAttribute('aria-hidden', 'true');
  rp.hidden = true;
  doc.body.appendChild(rp);
  doc.documentElement.classList.add('eg-rp-on');

  /* La feuille d'impression doit s'appliquer aussi à l'écran pour la mesure : media="print" devient "all". */
  doc.querySelectorAll('link[rel="stylesheet"][href*="eg-rcia-print"]').forEach((lk) => {
    if (lk.media && lk.media !== 'all') lk.media = 'all';
    lk.addEventListener('load', () => majImpression(), sig);
  });

  const toast = (msg, undo, err, ms, lien) => {
    const E = eg();
    if (E && typeof E.toast === 'function') E.toast(msg, undo || null, !!err, ms, lien || null);
  };
  /* 16/10 : configuration d'eg-app.js (#eg-config) pour le lien « Voir mon panier → » des messages d'ajout. */
  const egCfg = (() => { try { return JSON.parse(doc.getElementById('eg-config').textContent) || {}; } catch (e) { return {}; } })();
  const lienPanier = egCfg.cartUrl && egCfg.t && egCfg.t.voirPanier ? { href: egCfg.cartUrl, label: egCfg.t.voirPanier } : null;
  /* Ventes par recette (16/10, décomposition REA de Chronodrive) : la recette d'où vient un « Tout ajouter » est notée
     dans l'attribut de panier caché « _recettes » (handles, 20 au plus), visible dans la commande, sans dédoubler les
     lignes du panier (une propriété de ligne le ferait). Échec silencieux : l'ajout au panier ne dépend pas de lui. */
  async function noterRecette(h) {
    if (!h || typeof fetch !== 'function') return;
    const racine = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
    try {
      const c = await fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const l = String((c && c.attributes && c.attributes._recettes) || '').split(',').filter((x) => /^[a-z0-9-]{1,80}$/.test(x));
      if (l.includes(h)) return;
      l.push(h);
      await fetch(racine + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _recettes: l.slice(-20).join(',') } }) });
    } catch (e) { /* attribution perdue, panier intact */ }
  }

  const setLabel = (el, txt) => {
    if (!el) return;
    const l = el.querySelector('[data-l]');
    if (l) l.textContent = txt;
    else if (!el.firstElementChild) el.textContent = txt;
  };

  function conteneur(id, bloc) {
    const h = homes.get(id);
    if (h && h.bloc === bloc && h.el) return h.el;
    const s = root.querySelector('[data-rcia-bloc="' + bloc + '"]');
    if (!s) return h ? h.el : null;
    return s.querySelector('[data-rcia-liste]') || s;
  }

  function placer(id, bloc) {
    const r = rows.get(id);
    const c = conteneur(id, bloc);
    if (!r || !c || r.parentElement === c) return;
    const i = ordre.get(id);
    const apres = Array.from(c.children).find((x) => x.hasAttribute('data-rl') && ordre.has(x.getAttribute('data-rl')) && ordre.get(x.getAttribute('data-rl')) > i);
    const focus = r.contains(doc.activeElement) ? doc.activeElement : null;
    c.insertBefore(r, apres || null);
    if (focus && focus.isConnected) focus.focus({ preventScroll: true });
  }

  function majProduit(r, l, m) {
    if (r.getAttribute('data-rl-choix') === String(m.choix)) return;
    r.setAttribute('data-rl-choix', String(m.choix));
    const pr = produitCourant(l, m);
    if (!pr) return;
    const href = urlSure(pr.url);
    const img = r.querySelector('.ph img');
    if (img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      const s = sized(pr.img, 176);
      if (s) img.setAttribute('src', s);
    }
    r.querySelectorAll('a.ph, a.nm').forEach((a) => { if (href) a.setAttribute('href', href); });
    const nm = r.querySelector('.nm');
    if (nm) nm.textContent = nomCourt(pr.titre);
    const vd = r.querySelector('.vd');
    if (vd) vd.textContent = pr.vd || '';
    const qt = r.querySelector('.qt');
    if (qt) qt.textContent = pr.qline || '';
    const prx = r.querySelector('.pr');
    if (prx) prx.textContent = money(pr.prix);
    const ck = r.querySelector('[data-rl-ck]');
    if (ck) {
      const lab = ck.closest('label') && ck.closest('label').querySelector('.eg-sr');
      if (lab) lab.textContent = T('fiche.case', { produit: nomCourt(pr.titre) });
      else ck.setAttribute('aria-label', T('fiche.case', { produit: nomCourt(pr.titre) }));
    }
  }

  function majLigne(l) {
    const r = rows.get(l.id);
    const m = mod.lignes[l.id];
    if (!r || !m) return;
    const b = blocDe(l, m);
    const actif = caseActive(l, m);
    placer(l.id, b);
    r.setAttribute('data-st', b);
    r.classList.toggle('eg-rl-off', b === 'rupture');
    majProduit(r, l, m);
    const ck = r.querySelector('[data-rl-ck]');
    if (ck) { ck.disabled = !actif; ck.checked = !!(m.ck && actif); }
    /* Quantité locale active seulement sur une ligne cochée : on coche pour commander, puis on règle le nombre de
       paquets (une ligne décochée, ou mise à 0, se recoche par sa case, qui remet le nombre de paquets de la recette). */
    r.querySelectorAll('[data-rl-q]').forEach((bt) => {
      const plus = bt.getAttribute('data-rl-q') === '+1';
      bt.disabled = !(m.ck && actif) || (plus ? m.n >= PAQUETS_MAX : m.n <= 0);
    });
    const out = r.querySelector('[data-rl-n]');
    if (out) out.textContent = String(m.n);
    const need = r.querySelector('[data-rl-besoin]');
    if (need) {
      /* Carte produit : « 400 g nécessaires » ; ligne texte (frais, placard sans produit) : « 400 g ». */
      const q = quantite(l, mod.p);
      if (r.classList.contains('eg-rl-t')) need.textContent = Q(q, l.u);
      else need.textContent = q == null ? T('fiche.selon_gout') : T('fiche.besoin', { q: Q(q, l.u) });
    }
    /* Grand format : une note sous le format (« de quoi refaire la recette N fois »), cochée ou non. */
    const gfN = b === 'ok' ? grandFormat(l, m, mod.p) : 0;
    let gfe = r.querySelector('[data-rl-gf]');
    const qtx = r.querySelector('.qt');
    if (gfN && !gfe && qtx) {
      gfe = doc.createElement('span');
      gfe.className = 'eg-rl-gf';
      gfe.setAttribute('data-rl-gf', '');
      qtx.insertAdjacentElement('afterend', gfe);
    }
    if (gfe) {
      gfe.hidden = !gfN;
      gfe.textContent = gfN ? T(m.ck ? 'fiche.gf' : 'fiche.gf_off', { n: gfN }) : '';
    }
    const rem = r.querySelector('[data-rl-remplace]');
    if (rem) {
      rem.hidden = m.choix < 0;
      rem.textContent = m.choix < 0 ? '' : T('fiche.swap_remplace', { produit: nomCourt(l.p ? l.p.titre : l.nom) });
    }
    const soon = r.querySelector('[data-rl-bientot]');
    const pc = produitCourant(l, m);
    if (soon) soon.hidden = !(pc && !pc.dispo);
    const nob = r.querySelector('[data-rl-noubliez]');
    if (nob) nob.hidden = !(b === 'deja' && pc);
    const dj = r.querySelector('[data-rl-deja]');
    if (dj) {
      dj.hidden = l.st === 'placard';
      /* Le libellé change (« J'ai déjà » / « Je ne l'ai pas ») : il porte l'état. Un aria-pressed en plus ferait lire
         « Je ne l'ai pas, enfoncé » (WAI-ARIA APG : le libellé d'un bouton bascule ne change pas). */
      dj.removeAttribute('aria-pressed');
      setLabel(dj, T(m.dejaOn ? 'fiche.deja_retirer' : 'fiche.deja_btn'));
    }
    const sw = r.querySelector('[data-rl-swap]');
    if (sw) {
      sw.hidden = candidats(l, m).length === 0;
      setLabel(sw, T(b === 'rupture' ? 'fiche.remplacer' : 'fiche.changer'));
    }
  }

  function majQuantites() {
    root.querySelectorAll('[data-q]').forEach((s) => {
      const l = parId.get(s.getAttribute('data-q'));
      if (l) s.textContent = Q(quantite(l, mod.p), l.u);
    });
  }

  function majBlocs() {
    root.querySelectorAll('[data-rcia-bloc]').forEach((s) => {
      if (s.getAttribute('data-rcia-bloc') === 'accompagner') {
        const acc = s.querySelectorAll('[data-rcia-acc]');
        if (acc.length) s.hidden = !Array.from(acc).some((a) => !a.hidden);
        return;
      }
      s.hidden = !s.querySelector('[data-rl]');
    });
    root.querySelectorAll('[data-rcia-commerce]').forEach((g) => { g.hidden = !g.querySelector('[data-rl]'); });
  }

  function majPortions() {
    root.querySelectorAll('[data-rcia-pval]').forEach((o) => { o.textContent = T('fiche.valeur', { n: mod.p, count: mod.p }); });
    root.querySelectorAll('[data-rcia-p]').forEach((bt) => {
      const plus = bt.getAttribute('data-rcia-p') === '+1';
      bt.disabled = plus ? mod.p >= PORTIONS_MAX : mod.p <= PORTIONS_MIN;
    });
  }

  function majBudget() {
    const el = root.querySelector('[data-rcia-budget]');
    if (!el) return;
    const tr = trancheBudget(budgetPortion(etat, mod));
    el.hidden = !tr;
    const frais = lignes.some((l) => l.st === 'frais');
    el.textContent = tr ? T('fiche.budget_' + tr) + (frais ? ' · ' + T('fiche.budget_note') : '') : '';
  }

  function majPanier() {
    const sel = total(etat, mod);
    const plan = planAjout(etat, mod);
    const add = q1('[data-rcia-add]');
    if (add) {
      setLabel(add, plan.length ? T('fiche.tout_ajouter', { prix: money(sel) }) : T('fiche.rien'));
      if (!occupe) add.disabled = !plan.length;
    }
    const tot = q1('[data-rcia-total]');
    if (tot) tot.textContent = money(sel);
    const jz = q1('[data-rcia-jauge]');
    if (!jz) return;
    /* Seuil lu dans #eg-config seulement (R15) : sans seuil, pas de jauge plutôt qu'un montant inventé. */
    const seuil = num(egcfg.free);
    if (egcfg.gauge !== true || !(seuil > 0)) { jz.hidden = true; return; }
    let g = jz.querySelector('.gauge');
    let tx = jz.querySelector('[data-rcia-jauge-t]');
    if (!g) {
      g = doc.createElement('div');
      g.className = 'gauge';
      g.appendChild(doc.createElement('span'));
      jz.appendChild(g);
    }
    if (!tx) {
      tx = doc.createElement('small');
      tx.className = 'eg-rcia-jt';
      tx.setAttribute('data-rcia-jauge-t', '');
      jz.appendChild(tx);
    }
    const pmax = num(cfg.poids_max);
    const E = eg();
    const hp = horsPanier(plan, E && typeof E.qty === 'function' ? (k) => E.qty(k) : null);
    const j = jauge(panier.total, hp.montant, seuil, panier.poids + hp.poids, pmax);
    g.firstElementChild.style.width = j.pct + '%';
    tx.textContent = j.lourd ? T('fiche.poids', { max: nombre(pmax / 1000) }) : j.offerte ? T('fiche.jauge_ok') : T('fiche.jauge_reste', { montant: money(j.reste) });
    jz.hidden = false;
  }

  function majEntete() {
    const note = root.querySelector('[data-rcia-note]');
    if (note) {
      const on = !!(passage && passage.x.indexOf('temps') >= 0);
      if (on && !note.textContent.trim()) note.textContent = T('fiche.plus_long', { n: num(etat.total) });
      note.hidden = !on;
    }
    root.querySelectorAll('[data-rcia-act="idees"], [data-rcia-act="autre"]').forEach((b) => { b.hidden = !passage; });
    root.querySelectorAll('[data-rcia-acc]').forEach((a) => {
      if (enfants && a.getAttribute('data-alc') === 'true') a.hidden = true;
    });
    const alc = root.querySelector('[data-rcia-alcool]');
    if (alc) alc.hidden = !Array.from(root.querySelectorAll('[data-rcia-acc][data-alc="true"]')).some((a) => !a.hidden);
  }

  /* ---------- Impression ---------- */
  const el = (tag, cls, txt) => {
    const e = doc.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  };

  function urlFiche() { return urlBase ? urlBase + '#p=' + mod.p : ''; }

  /* QR code par vendor/qrcode.js (Shopify) : on lit sa matrice (_oQRCode) pour tracer un SVG net à l'impression ;
     sinon on garde l'image ou le canevas qu'il produit ; sans bibliothèque, null (l'adresse s'imprime en clair). */
  function noeudQR(texteQR) {
    const Q = win.QRCode;
    if (typeof Q !== 'function' || !texteQR) return null;
    try {
      const tmp = doc.createElement('div');
      const lvl = Q.CorrectLevel && Q.CorrectLevel.M != null ? Q.CorrectLevel.M : 0;
      const o = new Q(tmp, { text: texteQR, width: 256, height: 256, correctLevel: lvl });
      const m = o && o._oQRCode;
      if (m && typeof m.getModuleCount === 'function' && typeof m.isDark === 'function') {
        const n = m.getModuleCount();
        let d = '';
        for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (m.isDark(r, c)) d += 'M' + (c + 4) + ' ' + (r + 4) + 'h1v1h-1z';
        const w = doc.createElement('div');
        w.innerHTML = '<svg viewBox="0 0 ' + (n + 8) + ' ' + (n + 8) + '" shape-rendering="crispEdges" focusable="false"><rect width="' + (n + 8) + '" height="' + (n + 8) + '" fill="#fff"/><path fill="#000" d="' + d + '"/></svg>';
        return w.firstElementChild;
      }
      /* Sans matrice lisible : image du canevas dessiné par la bibliothèque (un canevas copié serait vide). */
      const cv = tmp.querySelector('canvas');
      if (cv && typeof cv.toDataURL === 'function') {
        const im = doc.createElement('img');
        im.setAttribute('alt', '');
        im.src = cv.toDataURL('image/png');
        return im;
      }
      const im0 = tmp.querySelector('img');
      return im0 && im0.getAttribute('src') ? im0 : null;
    } catch (e) {
      return null;
    }
  }

  function ligneCourse(l, qtxt, sous) {
    const li = el('li');
    if (qtxt) { li.appendChild(el('span', 'eg-rp-q', qtxt)); li.appendChild(doc.createTextNode(' ' + l.nom)); }
    else li.appendChild(doc.createTextNode(l.nom + ' (' + T('fiche.selon_gout') + ')'));
    if (sous) li.appendChild(el('small', null, sous));
    return li;
  }

  function contenuImpression() {
    const f = doc.createDocumentFragment();
    /* En-tête : logo, titre, portions et temps, mention IA, petite image. */
    const hd = el('header', 'eg-rp-hd');
    const ti = el('div', 'eg-rp-ti');
    const logo = urlSure(cfg.logo);
    if (logo) { const im = el('img', 'eg-rp-logo'); im.setAttribute('src', logo); im.setAttribute('alt', hote || 'ITALAZA'); ti.appendChild(im); }
    else ti.appendChild(el('span', 'eg-rp-marque', hote || 'ITALAZA'));
    ti.appendChild(el('h1', null, etat.titre || ''));
    const meta = [T('print.pour', { n: mod.p, count: mod.p })];
    if (num(etat.prep)) meta.push(T('fiche.preparation', { n: num(etat.prep) }));
    // Recettes de la bibliothèque (schéma 2) : leurs temps ne comptent pas la mise à ébullition de l'eau (R-bibliotheque § 7).
    if (num(etat.cuisson)) meta.push(T('fiche.cuisson', { n: num(etat.cuisson) }) + (etat.origine && T('fiche.hors_ebullition') ? ' (' + T('fiche.hors_ebullition') + ')' : ''));
    if (etat.niveau) meta.push(String(etat.niveau));
    if (etat.testee) meta.push(T('mention.testee'));
    ti.appendChild(el('p', 'eg-rp-meta', meta.join(' · ')));
    hd.appendChild(ti);
    const src = sized(etat.img, 480);
    if (src) {
      const fig = el('figure', 'eg-rp-img');
      const im = el('img');
      im.setAttribute('src', src);
      im.setAttribute('alt', '');
      fig.appendChild(im);
      let leg = '';
      if (etat.img_legende === 'ia') leg = T('mention.image_ia');
      else if (etat.img_legende === 'produit') {
        /* Légende reprise de la page (.eg-rcia-leg, rendue par L3a avec le produit réellement photographié) : la
           feuille ne peut pas nommer un autre produit que celui de l'image. Repli : premier produit de la recette. */
        const lp = root.querySelector('.eg-rcia-leg');
        if (lp && lp.textContent.trim()) leg = lp.textContent.trim();
        else if (t['mention.photo_produit']) {
          const p0 = lignes.find((l) => l.p && l.st !== 'placard');
          leg = T('mention.photo_produit', { produit: p0 ? nomCourt(p0.p.titre) : '' });
        }
      }
      if (leg) fig.appendChild(el('figcaption', null, leg));
      hd.appendChild(fig);
    }
    f.appendChild(hd);

    /* Colonne gauche : liste de courses en trois groupes (quantités des portions choisies, aucun prix).
       Une rupture qui a un remplaçant disponible reste « Chez ITALAZA », sous le nom du remplaçant (point 10, R-plan
       § 1.4) : seuls les produits sans remplaçant, rendus « frais » dans « ailleurs », vont à « À trouver ailleurs ». */
    const chez = [];
    const prevoir = [];
    const deja = [];
    lignes.forEach((l) => {
      const m = mod.lignes[l.id];
      const b = blocDe(l, m);
      const pr = produitCourant(l, m);
      const q = quantite(l, mod.p);
      const qtxt = q == null ? '' : Q(q, l.u);
      if (b === 'ok' || (b === 'deja' && m.ck && caseActive(l, m))) chez.push(ligneCourse(l, qtxt, pr ? nomCourt(pr.titre) : ''));
      else if (b === 'rupture') {
        const c0 = candidats(l, m)[0];
        chez.push(ligneCourse(l, qtxt, c0 ? nomCourt(c0.p.titre) : ''));
      } else if (b === 'frais') {
        const c = COMMERCES.indexOf(l.commerce) >= 0 || l.commerce === AILLEURS ? l.commerce : 'divers';
        prevoir.push({ rang: COMMERCES.concat([AILLEURS]).indexOf(c), li: ligneCourse(l, qtxt, T('commerce.' + c)) });
      } else deja.push(ligneCourse(l, qtxt, pr && pr.dispo ? T('print.eg') + DP + nomCourt(pr.titre) : ''));
    });
    const cols = el('div', 'eg-rp-cols');
    const g = el('section', 'eg-rp-courses');
    g.appendChild(el('h2', null, T('print.courses')));
    const groupe = (titre, items) => {
      if (!items.length) return;
      g.appendChild(el('h3', null, titre));
      const ul = el('ul');
      items.forEach((li) => ul.appendChild(li));
      g.appendChild(ul);
    };
    groupe(T('print.eg'), chez);
    groupe(T('print.frais'), prevoir.sort((a, b) => a.rang - b.rang).map((x) => x.li));
    groupe(T('print.deja'), deja);
    /* « Pour accompagner » : suggestions sans alcool seulement (loi Évin, Q4 en attente), noms seuls. */
    const acc = etat.acc.filter((a) => a && a.dispo && !a.alc).map((a) => nomCourt(a.titre)).filter(Boolean);
    if (acc.length) {
      const pa = el('p', 'eg-rp-acc');
      pa.appendChild(el('b', null, T('fiche.accompagner') + DP));
      pa.appendChild(doc.createTextNode(acc.join(' · ')));
      g.appendChild(pa);
    }
    cols.appendChild(g);

    /* Colonne droite : étapes (copie du DOM de la page, quantités déjà à jour, alertes comprises) et astuce. */
    const prep = el('section', 'eg-rp-prep');
    prep.appendChild(el('h2', null, T('print.preparation')));
    const ol = el('ol', 'eg-rp-steps');
    const src2 = root.querySelector('[data-rcia-etapes]') || root.querySelector('.eg-steps');
    if (src2) {
      Array.from(src2.children).forEach((li0) => {
        if (li0.tagName !== 'LI') return;
        const c = li0.cloneNode(true);
        c.querySelectorAll('button, input, script, [id]').forEach((x) => { if (x.matches('button, input, script')) x.remove(); else x.removeAttribute('id'); });
        const li = el('li');
        const corps = el('div', 'eg-rp-st');
        while (c.firstChild) corps.appendChild(c.firstChild);
        li.appendChild(corps);
        ol.appendChild(li);
      });
    }
    prep.appendChild(ol);
    const ast = root.querySelector('[data-rcia-astuce]');
    if (ast && ast.textContent.trim()) {
      const a = el('p', 'eg-rp-astuce');
      a.appendChild(el('b', null, T('print.astuce') + DP));
      a.appendChild(doc.createTextNode(ast.textContent.trim()));
      prep.appendChild(a);
    }
    cols.appendChild(prep);
    f.appendChild(cols);

    /* Pied : allergènes probables, mention IA, QR code (ou adresse en clair). */
    const ft = el('footer', 'eg-rp-ft');
    const tx = el('div', 'eg-rp-fttx');
    const all = (etat.allergenes || []).map((a) => T('allergene.' + a)).filter(Boolean);
    if (all.length) tx.appendChild(el('p', 'eg-rp-all', T('allergenes', { liste: all.join(', ') })));
    /* Mention IA : comme sur la page (L3a), pour les recettes du schéma 2 seulement (origine « ia ») ; une recette v1
       d'origine inconnue ne porte pas sur papier une mention que sa page n'affiche pas (A-L3a-10). */
    // Sprint 1 (16/10) : recette générée en direct (origine « ia_direct »), non relue : sa propre mention.
    if (etat.origine) tx.appendChild(el('p', 'eg-rp-mention', T(etat.origine === 'ia_direct' ? 'mention.recette_directe' : 'mention.recette')));
    ft.appendChild(tx);
    const u = urlFiche();
    if (qr.url !== u || !qr.noeud) qr = { url: u, noeud: noeudQR(u) };
    const bq = el('div', 'eg-rp-qrb');
    if (qr.noeud) {
      const box = el('div', 'eg-rp-qr');
      box.setAttribute('data-rcia-qr', '');
      box.appendChild(qr.noeud.cloneNode(true));
      bq.appendChild(box);
    }
    bq.appendChild(el('p', 'eg-rp-qrtx', T('print.qr')));
    if (u) bq.appendChild(el('p', 'eg-rp-url', qr.noeud ? hote : u));
    ft.appendChild(bq);
    f.appendChild(ft);
    rp.classList.toggle('eg-rp-sansqr', !qr.noeud);
    return f;
  }

  const mmPx = 96 / 25.4;
  function mesurer(classes) {
    const c = rp.cloneNode(true);
    c.removeAttribute('id');
    c.hidden = false;
    REDUCTIONS.forEach((k) => c.classList.remove(k));
    c.classList.add('eg-rp-mesure');
    classes.forEach((k) => c.classList.add(k));
    doc.body.appendChild(c);
    const h = c.getBoundingClientRect().height;
    c.remove();
    return h;
  }

  let dernier = null;
  function majImpression() {
    if (ctl.signal.aborted) return;
    rp.replaceChildren(contenuImpression());
    const res = choisirReduction(mesurer, (A4.hauteurMm - A4.securiteMm) * mmPx, sansImage || !etat.img);
    REDUCTIONS.forEach((k) => rp.classList.toggle(k, res.classes.indexOf(k) >= 0));
    rp.setAttribute('data-rp-tient', res.tient ? 'oui' : 'non');
    rp.setAttribute('data-rp-hauteur-mm', String(Math.round(res.hauteur / mmPx)));
    dernier = res;
  }

  function rendre() {
    lignes.forEach(majLigne);
    majQuantites();
    majBlocs();
    majPortions();
    majBudget();
    majPanier();
    majImpression();
  }

  /* ---------- Actions ---------- */
  function changerPortions(d) {
    const p = Math.min(PORTIONS_MAX, Math.max(PORTIONS_MIN, mod.p + d));
    if (p === mod.p) return;
    mod.p = p;
    lignes.forEach((l) => {
      const m = mod.lignes[l.id];
      m.n = paquets(l, p, contenance(l, m));
      if (!m.touche && blocDe(l, m) === 'ok') m.ck = caseActive(l, m) && !grandFormat(l, m, p);
    });
    try { win.history.replaceState(win.history.state, '', '#p=' + p); } catch (e) { /* adresse inchangée */ }
    rendre();
  }

  function choisir(l, k) {
    const m = mod.lignes[l.id];
    m.choix = k;
    m.n = paquets(l, mod.p, contenance(l, m));
    /* Choisir un autre produit ou format, c'est vouloir l'acheter : la ligne se coche (grand format compris). */
    if (blocDe(l, m) === 'ok') { m.ck = caseActive(l, m); m.touche = true; }
    if (!caseActive(l, m)) m.ck = false;
    rendre();
  }

  function ouvrirSwap(l, bouton) {
    const m = mod.lignes[l.id];
    const E = eg();
    const cands = candidats(l, m);
    if (!cands.length) return;
    if (!E || typeof E.sheet !== 'function') { choisir(l, cands[0].k); return; }
    const cur = produitCourant(l, m);
    const opts = (cur && cur.dispo ? [{ k: m.choix, p: cur, c: contenance(l, m), actuel: true }] : []).concat(cands);
    let h = '<b>' + esc(T('fiche.swap_titre', { produit: nomCourt(cur ? cur.titre : l.nom) })) + '</b><div class="list eg-rcia-sw">';
    /* Chaque « Choisir » est décrit par le nom de son produit (aria-describedby) : sinon un lecteur d'écran entend
       plusieurs boutons « Choisir » identiques. */
    opts.forEach((o, j) => {
      const im = sized(o.p.img, 128);
      h += '<div class="row"><span class="ph">' + (im ? '<img src="' + esc(im) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
        '<div class="in"><span class="nm" id="eg-rcia-sw-' + Number(j) + '">' + esc(nomCourt(o.p.titre)) + '</span>' + (o.p.vd ? '<span class="vd">' + esc(o.p.vd) + '</span>' : '') +
        '<span class="qt">' + esc(o.p.qline || '') + '</span></div><div class="rt"><span class="pr">' + esc(money(o.p.prix)) + '</span>' +
        (o.actuel ? '<span class="eg-rcia-sw-cur">' + esc(T('fiche.swap_actuel')) + '</span>'
          : '<button type="button" class="cta eg-rcia-sw-b" data-rcia-swap-i="' + Number(o.k) + '" aria-describedby="eg-rcia-sw-' + Number(j) + '">' + esc(T('fiche.swap_choisir')) + '</button>') + '</div></div>';
    });
    h += '</div><button type="button" class="cta ghost" data-sheet-close>' + esc(T('fiche.fermer')) + '</button>';
    const bg = E.sheet(h);
    if (!bg) return;
    bg.addEventListener('click', (e) => {
      const b = e.target.closest('[data-rcia-swap-i]');
      if (!b) return;
      e.preventDefault();
      const k = Number(b.getAttribute('data-rcia-swap-i'));
      if (!cands.some((c) => c.k === k)) return;
      if (typeof E.closeSheet === 'function') E.closeSheet();
      choisir(l, k);
      if (bouton && bouton.isConnected && !bouton.hidden) bouton.focus({ preventScroll: true });
    });
  }

  function montrerTexte(titre, corps, sms) {
    const E = eg();
    if (!E || typeof E.sheet !== 'function') return;
    let h = '<b>' + esc(titre) + '</b><pre class="eg-rcia-liste-txt" tabindex="0">' + esc(corps) + '</pre>';
    if (sms) h += '<a class="cta" href="' + esc('sms:?&body=' + encodeURIComponent(corps)) + '">' + esc(T('fiche.sms')) + '</a>';
    if (win.navigator.clipboard && win.navigator.clipboard.writeText) h += '<button type="button" class="cta ghost" data-rcia-copier>' + esc(T('fiche.copier')) + '</button>';
    h += '<button type="button" class="cta ghost" data-sheet-close>' + esc(T('fiche.fermer')) + '</button>';
    const bg = E.sheet(h);
    if (!bg) return;
    bg.addEventListener('click', (e) => {
      if (!e.target.closest('[data-rcia-copier]')) return;
      e.preventDefault();
      win.navigator.clipboard.writeText(corps).then(() => toast(sms ? T('fiche.liste_copiee') : T('fiche.lien_copie')), () => {});
    });
  }

  function partager() {
    const u = urlFiche();
    if (!u) return;
    const n = win.navigator;
    if (n.share) { n.share({ title: etat.titre || '', url: u }).catch(() => {}); return; }
    if (n.clipboard && n.clipboard.writeText) { n.clipboard.writeText(u).then(() => toast(T('fiche.lien_copie')), () => montrerTexte(etat.titre || '', u, false)); return; }
    montrerTexte(etat.titre || '', u, false);
  }

  function envoyerListe() {
    const txt = listeTexte(etat, mod, t, lang);
    const n = win.navigator;
    if (n.share) { n.share({ title: T('fiche.liste_titre', { titre: etat.titre, n: mod.p, count: mod.p }), text: txt }).catch(() => {}); return; }
    montrerTexte(T('fiche.liste_titre', { titre: etat.titre, n: mod.p, count: mod.p }), txt, true);
  }

  function ouvrirImpression() {
    const E = eg();
    if (!E || typeof E.sheet !== 'function') { win.print(); return; }
    let h = '<b>' + esc(T('print.titre')) + '</b>';
    if (etat.img) h += '<label class="eg-check eg-rcia-pchk"><input type="checkbox" data-rcia-print-noimg' + (sansImage ? ' checked' : '') + '><span>' + esc(T('print.sans_image')) + '</span></label>';
    h += '<p class="eg-rcia-paide">' + esc(T('print.pdf')) + '</p><button type="button" class="cta" data-rcia-print-go>' + esc(T('print.ok')) +
      '</button><button type="button" class="cta ghost" data-sheet-close>' + esc(T('fiche.fermer')) + '</button>';
    const bg = E.sheet(h);
    if (!bg) return;
    bg.addEventListener('change', (e) => {
      const c = e.target.closest('[data-rcia-print-noimg]');
      if (!c) return;
      sansImage = !!c.checked;
      majImpression();
    });
    bg.addEventListener('click', (e) => {
      if (!e.target.closest('[data-rcia-print-go]')) return;
      e.preventDefault();
      if (typeof E.closeSheet === 'function') E.closeSheet();
      majImpression();
      win.print();
    });
  }

  /* Panier relu sur le serveur (E.refresh passe par la file d'eg-app.js, donc après les changements en cours) :
     quantités par variante, ou null si la relecture échoue. */
  async function relirePanier(E) {
    if (typeof E.refresh !== 'function') return null;
    try { return qtesPanier(await E.refresh()); } catch (e) { return null; }
  }

  async function toutAjouter(btn) {
    if (occupe) return;
    const E = eg();
    if (!E || typeof E.addMany !== 'function' || typeof E.qty !== 'function') return;
    const plan = planAjout(etat, mod).map((it) => ({ id: it.id, quantity: it.quantity }));
    if (!plan.length) { toast(T('fiche.rien')); return; }
    occupe = true;
    const avaitFocus = doc.activeElement === btn;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      const lu = await relirePanier(E);
      const avant = new Map(plan.map((it) => [String(it.id), lu ? lu.get(String(it.id)) || 0 : E.qty(it.id)]));
      let apres = null;
      try {
        await E.addMany(plan);
        /* Panier relu sur le serveur, pas E.get() : addMany ne rejette plus quand sa propre relecture échoue (eg-app.js,
           audit J2) ; le panier en mémoire peut alors dater d'avant l'ajout et le bilan dirait « aucun produit
           ajouté », d'où un second clic et des doublons (contre-vérification G5, J2). Une requête de plus, au clic. */
        apres = await relirePanier(E);
      } catch (err) {
        /* Envoi groupé refusé (une variante épuisée suffit), ou ajout fait mais panier non relu ensuite (audit J2) :
           relire le panier et ne reprendre, produit par produit, que les variantes qui n'y ont pas augmenté.
           Panier illisible : aucune reprise, un second envoi pourrait mettre les produits en double. */
        apres = await relirePanier(E);
        if (apres) {
          for (const it of plan) {
            const k = String(it.id);
            if ((apres.get(k) || 0) > avant.get(k)) continue;
            try { await E.addMany([it]); } catch (e2) { /* variante non ajoutée */ }
          }
          apres = await relirePanier(E);
        }
      }
      if (!apres) { toast(T('fiche.non_relu'), null, true); return; }
      const b = bilanAjout(plan, avant, (k) => apres.get(k) || 0);
      if (!b.ok) toast(T('fiche.aucun_ajout'), null, true);
      else {
        let fait = false;
        const annuler = async () => {
          if (fait) return;
          fait = true;
          /* Quantités du serveur, pas E.qty() : ne jamais retirer une unité que le client avait avant (audit J6). */
          const maintenant = await relirePanier(E);
          if (!maintenant) { toast(T('fiche.non_relu'), null, true); return; }
          for (const c of ciblesAnnulation(b.ajoutes, (k) => maintenant.get(k) || 0)) {
            try { await E.setQty(c.vid, c.q); } catch (e4) { /* message générique d'eg-app.js */ }
          }
          toast(T('fiche.annule'));
        };
        toast(b.ko ? T('fiche.partiel', { ok: b.ok, ko: b.ko }) : T('fiche.ajoutes', { n: b.ok, count: b.ok }), annuler, false, 10000, lienPanier);
        noterRecette(etat.h);
      }
    } finally {
      occupe = false;
      btn.removeAttribute('aria-busy');
      majPanier();
      if (avaitFocus && btn.isConnected && !btn.disabled) btn.focus({ preventScroll: true });
    }
  }

  const ACTIONS = '[data-rcia-p],[data-rl-q],[data-rl-deja],[data-rl-swap],[data-rcia-act],[data-rcia-add]';
  const bar = q1('[data-rcia-bar]');
  function onClick(e) {
    const b = e.target.closest(ACTIONS);
    if (!b || b.disabled) return;
    if (!root.contains(b) && !(bar && bar.contains(b))) return;
    if (b.hasAttribute('data-rcia-add')) { e.preventDefault(); toutAjouter(b); return; }
    if (b.hasAttribute('data-rcia-act')) {
      const a = b.getAttribute('data-rcia-act');
      if (a === 'modifier') return; /* lien vers l'arbre : navigation normale */
      e.preventDefault();
      if (a === 'imprimer') ouvrirImpression();
      else if (a === 'partager') partager();
      else if (a === 'envoyer') envoyerListe();
      else if (a === 'idees' || a === 'autre') {
        if (win.history.length > 1) win.history.back();
        else if (urlSure(cfg.recettes)) win.location.href = urlSure(cfg.recettes);
      }
      return;
    }
    if (b.hasAttribute('data-rcia-p')) { e.preventDefault(); changerPortions(b.getAttribute('data-rcia-p') === '+1' ? 1 : -1); return; }
    const r = b.closest('[data-rl]');
    const l = r && parId.get(r.getAttribute('data-rl'));
    if (!l) return;
    const m = mod.lignes[l.id];
    e.preventDefault();
    if (b.hasAttribute('data-rl-q')) {
      const plus = b.getAttribute('data-rl-q') === '+1';
      if (!caseActive(l, m)) return;
      /* « − 1 + » ne règle que les lignes cochées (désactivé sinon, voir majLigne) : un nombre de paquets ne monte
         jamais sur une ligne qui ne partira pas au panier. Rien n'est envoyé ici (« Tout ajouter » seul). */
      if (!m.ck) return;
      m.n = Math.min(PAQUETS_MAX, Math.max(0, m.n + (plus ? 1 : -1)));
      if (m.n === 0) m.ck = false;
      rendre();
    } else if (b.hasAttribute('data-rl-deja')) {
      if (l.st === 'placard') return;
      m.dejaOn = !m.dejaOn;
      m.ck = !m.dejaOn && blocDe(l, m) === 'ok' && caseActive(l, m);
      if (m.ck && m.n === 0) m.n = paquets(l, mod.p, contenance(l, m));
      rendre();
    } else if (b.hasAttribute('data-rl-swap')) ouvrirSwap(l, b);
  }

  function onChange(e) {
    const c = e.target.closest('[data-rl-ck]');
    if (!c) return;
    const r = c.closest('[data-rl]');
    const l = r && parId.get(r.getAttribute('data-rl'));
    if (!l) return;
    const m = mod.lignes[l.id];
    m.ck = !!c.checked && caseActive(l, m);
    m.touche = true;
    if (m.ck && m.n === 0) m.n = paquets(l, mod.p, contenance(l, m));
    rendre();
  }

  root.addEventListener('click', onClick, sig);
  if (bar && !root.contains(bar)) bar.addEventListener('click', onClick, sig);
  root.addEventListener('change', onChange, sig);
  doc.addEventListener('eg:cart', (e) => {
    const c = (e && e.detail) || {};
    if (c.total_price != null) panier.total = num(c.total_price);
    if (c.total_weight != null) panier.poids = num(c.total_weight);
    majPanier();
  }, sig);
  win.addEventListener('load', () => { qr = { url: null, noeud: null }; majImpression(); }, sig);
  win.addEventListener('beforeprint', () => majImpression(), sig);
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(() => majImpression(), () => {});

  majEntete();
  rendre();
  if (adr.imprimer) {
    try { win.history.replaceState(win.history.state, '', '#p=' + mod.p); } catch (e) { /* adresse inchangée */ }
    win.setTimeout(ouvrirImpression, 0);
  }

  return {
    etat, mod, root, rp, rendre, majImpression,
    reduction: () => dernier,
    detruire() {
      ctl.abort();
      rp.remove();
      doc.documentElement.classList.remove('eg-rp-on');
    }
  };
}

/* Démarrage automatique dans le navigateur (et relance dans l'éditeur de thème). */
if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  const boot = (scope) => {
    (scope || document).querySelectorAll('[data-rcia-fiche]').forEach((r) => {
      if (!r.__egRcia) r.__egRcia = init(r) || true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:unload', (e) => {
    const r = e.target && e.target.querySelector && e.target.querySelector('[data-rcia-fiche]');
    if (r && r.__egRcia && r.__egRcia.detruire) r.__egRcia.detruire();
  });
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
}
